// FETCH ALL GENERAL PO DETAILS
export const FETCH_ACCESSORIES_PO_DETAILS_REQUEST_DK = 'FETCH_ACCESSORIES_PO_DETAILS_REQUEST_DK';
export const FETCH_ACCESSORIES_PO_DETAILS_SUCCESS_DK = 'FETCH_ACCESSORIES_PO_DETAILS_SUCCESS_DK';
export const FETCH_ACCESSORIES_PO_DETAILS_FAILURE_DK = 'FETCH_ACCESSORIES_PO_DETAILS_FAILURE_DK';

// FETCH ALL GENERAL PO DETAILS
export const FETCH_ACCESSORIES_PO_DETAILS_WITHOUT_ID_REQUEST_DK = 'FETCH_ACCESSORIES_PO_DETAILS_WITHOUT_ID_REQUEST_DK';
export const FETCH_ACCESSORIES_PO_DETAILS_WITHOUT_ID_SUCCESS_DK = 'FETCH_ACCESSORIES_PO_DETAILS_WITHOUT_ID_SUCCESS_DK';
export const FETCH_ACCESSORIES_PO_DETAILS_WITHOUT_ID_FAILURE_DK = 'FETCH_ACCESSORIES_PO_DETAILS_WITHOUT_ID_FAILURE_DK';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_ACCESSORIES_PO_DETAILS_GROUP_LIST_REQUEST_DK = 'FETCH_ACCESSORIES_PO_DETAILS_GROUP_LIST_REQUEST_DK';
export const FETCH_ACCESSORIES_PO_DETAILS_GROUP_LIST_SUCCESS_DK = 'FETCH_ACCESSORIES_PO_DETAILS_GROUP_LIST_SUCCESS_DK';
export const FETCH_ACCESSORIES_PO_DETAILS_GROUP_LIST_FAILURE_DK = 'FETCH_ACCESSORIES_PO_DETAILS_GROUP_LIST_FAILURE_DK';

// CREATE GENERAL PO DETAILS
export const CREATE_ACCESSORIES_PO_DETAILS_REQUEST_DK = 'CREATE_ACCESSORIES_PO_DETAILS_REQUEST_DK';
export const CREATE_ACCESSORIES_PO_DETAILS_SUCCESS_DK = 'CREATE_ACCESSORIES_PO_DETAILS_SUCCESS_DK';
export const CREATE_ACCESSORIES_PO_DETAILS_FAILURE_DK = 'CREATE_ACCESSORIES_PO_DETAILS_FAILURE_DK';

// UPDATE GENERAL PO DETAILS
export const UPDATE_ACCESSORIES_PO_DETAILS_REQUEST_DK = 'UPDATE_ACCESSORIES_PO_DETAILS_REQUEST_DK';
export const UPDATE_ACCESSORIES_PO_DETAILS_SUCCESS_DK = 'UPDATE_ACCESSORIES_PO_DETAILS_SUCCESS_DK';
export const UPDATE_ACCESSORIES_PO_DETAILS_FAILURE_DK = 'UPDATE_ACCESSORIES_PO_DETAILS_FAILURE_DK';

// FETCH SINGLE STATE OF GENERAL PO DETAILS
export const FETCH_SINGLE_ACCESSORIES_PO_DETAILS_REQUEST_DK = 'FETCH_SINGLE_ACCESSORIES_PO_DETAILS_REQUEST_DK';
export const FETCH_SINGLE_ACCESSORIES_PO_DETAILS_SUCCESS_DK = 'FETCH_SINGLE_ACCESSORIES_PO_DETAILS_SUCCESS_DK';
export const FETCH_SINGLE_ACCESSORIES_PO_DETAILS_FAILURE_DK = 'FETCH_SINGLE_ACCESSORIES_PO_DETAILS_FAILURE_DK';

// DELETE GENERAL PO DETAILS
export const DELETE_ACCESSORIES_PO_DETAILS_REQUEST_DK = 'DELETE_ACCESSORIES_PO_DETAILS_REQUEST_DK';
export const DELETE_ACCESSORIES_PO_DETAILS_SUCCESS_DK = 'DELETE_ACCESSORIES_PO_DETAILS_SUCCESS_DK';
export const DELETE_ACCESSORIES_PO_DETAILS_FAILURE_DK = 'DELETE_ACCESSORIES_PO_DETAILS_FAILURE_DK';

export const RESET_ACCESSORIES_PO_DETAILS_INFO_DK = 'RESET_ACCESSORIES_PO_DETAILS_INFO_DK';

export const CREATE_ACCESSORIES_PO_DETAILS_FORM_DK = 'CREATE_ACCESSORIES_PO_DETAILS_FORM_DK';

export const UPDATE_ACCESSORIES_PO_DETAILS_FORM_DK = 'UPDATE_ACCESSORIES_PO_DETAILS_FORM_DK';

export const FETCH_ACCESSORIES_PO_PREVIOUS_LIST_REQUEST_DK = 'FETCH_ACCESSORIES_PO_PREVIOUS_LIST_REQUEST_DK';
export const FETCH_ACCESSORIES_PO_PREVIOUS_LIST_SUCCESS_DK = 'FETCH_ACCESSORIES_PO_PREVIOUS_LIST_SUCCESS_DK';
export const FETCH_ACCESSORIES_PO_PREVIOUS_LIST_FAILURE_DK = 'FETCH_ACCESSORIES_PO_PREVIOUS_LIST_FAILURE_DK';

